import { ApiDataQuery, BaseAPIClient, Paginated, Report } from '@mi-front/core';

export const ReportsAPI = {
  async fetchReport<R extends Report>(this: BaseAPIClient, id: string): Promise<R> {
    return this.get(`/reports/${id}`);
  },

  async deleteReport(this: BaseAPIClient, id: string): Promise<void> {
    await this.delete(`/reports/${id}`);
  },

  /**
   * Lists saved reports via `GET /reports` using nested `filter[...]` query params.
   * Top-level field params (e.g. `createdById=`) are ignored by the API — only `filter` becomes WHERE.
   */
  async fetchReports(
    this: BaseAPIClient,
    args: ApiDataQuery<{
      createdById?: string;
      /** Report type discriminator, e.g. AUDIT_GIP_STATUS */
      type?: string;
      /** Case-insensitive name substring (`filter[name.like]`). */
      nameLike?: string;
      /** Inclusive createdAt lower bound (`filter[createdAt.gte]`). */
      createdAtFrom?: string;
      /** Inclusive createdAt upper bound (`filter[createdAt.lte]`). */
      createdAtTo?: string;
    }>,
  ): Promise<Paginated<Report>> {
    const {
      createdById,
      type,
      nameLike,
      createdAtFrom,
      createdAtTo,
      page,
      pageSize,
      sort,
      select,
    } = args;

    return this.get(`/reports`, {
      params: {
        page,
        pageSize,
        sort,
        select: select?.join(','),
        contain: 'createdBy',
        filter: {
          createdById,
          type,
          ...(nameLike ? { 'name.like': nameLike } : {}),
          ...(createdAtFrom ? { 'createdAt.gte': createdAtFrom } : {}),
          ...(createdAtTo ? { 'createdAt.lte': createdAtTo } : {}),
        },
      },
    });
  },
};
